let el
let form
let error
let errorCount = 0
let errorCap = 1
let isErrorOpen = false

export function TrackForm() {
    el = document.querySelector('.js-track')

    if (!el) {
        return
    }

    error = el.querySelector('.js-track-form-error')
    form = el.querySelector('.js-track-form')

    import('../form/controller')
        .then((module) => {
            module.FormController(form, handleReturn(module.handleReturn))
        })
        .then(() => {
            const currentUrl = new URL(window.location)
            if (currentUrl.searchParams.get('trackError') === 'true') {
                const inputs = form.querySelectorAll('[name]')
                Array.from(inputs).forEach((input) => {
                    const value = currentUrl.searchParams.get(input.name)
                    if (value) {
                        input.value = value
                    }
                })
                el.scrollIntoView()
                form.querySelector('button').click()
            }

            if (currentUrl.searchParams.get('helpDialog') === 'true') {
                el.scrollIntoView()
                el.querySelector('.u-info-btn').click()
            }
        })
}

function handleReturn(parentHandleReturn) {
    return function ({ data }) {
        if (!data) {
            return
        }

        parentHandleReturn.call(this, { data }, false)

        if (!data.success) {
            errorCount++
        }

        if (!isErrorOpen && errorCount > errorCap) {
            openError()
        }
    }
}

function openError() {
    isErrorOpen = true
    error.hidden = false
    error.style.height = Math.ceil(error.scrollHeight) + 'px'
    error.dataset.active = true
}
